import * as types from '../actions/action-types';
import _ from 'lodash';

const initialState = {};

const userReducer = function(state = initialState, action) {
  // console.log('action', action.type, action);
  // console.log('state', state);

  switch(action.type) {
    case types.GET_USER_PROFILE_SUCCESS:
      return Object.assign({}, state, action.userProfile);
    case types.LOGIN_FAILED:
      return Object.assign({}, {loginError: {status: action.status, message: action.message}});
    case types.LOGIN_SUCCESS:
      return Object.assign({}, state,{
        loginError: null,
        showModal: false
      });
    case types.LOGOUT_SUCCESS:
      return {};
    default:
      return state;
  }

};

export default userReducer;
